import { css, styled } from 'styled-components';
import { ThemeProps } from '../../themes';

interface RootProps {
    $align: string;
    $childMargin?: number;
    $divider?: boolean;
    $fillParent: boolean;
    $gap?: number;
    $justify: string;
    $noWrap?: boolean;
    $overflow?: string;
    $reverse?: boolean;
    $paddingVertical?: number;
    $paddingHorizontal?: number;
}

export const Root = styled.div<ThemeProps<RootProps>>`
    display: flex;
    flex-wrap: ${({ $noWrap }) => ($noWrap ? 'nowrap' : 'wrap')};
    flex-direction: ${({ $reverse }) => ($reverse ? 'row-reverse' : 'row')};
    justify-content: ${({ $justify }) => $justify};
    align-items: ${({ $align }) => $align};
    padding: ${({ theme, $paddingVertical = 0, $paddingHorizontal = 0 }) =>
        `${theme.spacing($paddingVertical)} ${theme.spacing($paddingHorizontal)}`};
    ${({ $fillParent }) => $fillParent && 'flex: 1;'}

    & > * {
        flex-shrink: 1;
    }

    ${({ $gap, theme, $childMargin }) =>
        $gap != null
            ? css`
                  gap: ${$gap}px;
              `
            : css`
                  gap: ${theme.spacing($childMargin ?? 2)};
              `}

    ${({ $overflow }) => $overflow && `overflow: ${$overflow};`}

  ${({ $divider, theme }) =>
        $divider &&
        css`
            position: relative;
            margin-bottom: ${theme.spacing(13)} !important;
            &:after {
                content: '';
                background: ${theme.groupDivider};
                position: absolute;
                bottom: -${theme.spacing(6)};
                left: 0;
                width: 100%;
                height: 1px;
            }
        `}
`;
